import { ArrowRight } from "lucide-react";
import { useState } from "react";
import { HiMenuAlt2 } from "react-icons/hi";
import { Link } from "react-router-dom";

import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet/sheet";

export const MobileSheet = () => {
  const [open, setOpen] = useState(false);

  const mobileMenuList = [
    {
      id: "leave-application",
      title: "Leave Applications",
      href: "/employee/leave-applications",
    },
  ];

  return (
    <>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetTrigger asChild>
          <button className="group transition-all duration-300 hover:bg-ring/10 p-1.5 rounded-full active:scale-[0.95] sm:hidden">
            <HiMenuAlt2 className="w-5 h-5" />
          </button>
        </SheetTrigger>
        <SheetContent side="left">
          <SheetHeader>
            <SheetTitle>Management</SheetTitle>
          </SheetHeader>

          <div className="mt-4 flex flex-col gap-2">
            {mobileMenuList?.map((ml) => {
              return (
                <Link
                  to={ml.href}
                  key={ml.id}
                  className="p-1 text-center flex items-center gap-3"
                  onClick={() => setOpen(false)}
                >
                  <span>{ml.title}</span>
                  <ArrowRight className="w-3 h-3" />
                </Link>
              );
            })}
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
};
